import { render, staticRenderFns } from "./DataTableByTrx.vue?vue&type=template&id=64a797a8"
import script from "./DataTableByTrx.vue?vue&type=script&lang=js"
export * from "./DataTableByTrx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports